import { useQuery } from '@tanstack/react-query';

import { categoryService } from '@/services/categoryService';

// Só leitura — ver nota em `useTutorials`.
//
// As variações por id (`useCategoryById`, `useCategoryChildren`,
// `useCategoryWithChildren`) sumiram: o BFF devolve o catálogo inteiro numa
// requisição, então filtrar em memória é mais rápido do que uma rota por
// recorte — e são menos endpoints para manter dos dois lados.

export const useCategories = () =>
  useQuery({
    queryKey: ['categorias'],
    queryFn: () => categoryService.list(),
    staleTime: 10 * 60 * 1000,
  });

export const useCategoriesHierarchical = () =>
  useQuery({
    queryKey: ['categorias', 'arvore'],
    queryFn: () => categoryService.tree(),
    staleTime: 10 * 60 * 1000,
  });

export const useCategory = (slug: string | undefined) =>
  useQuery({
    queryKey: ['categorias', 'slug', slug],
    queryFn: async () => {
      const todas = await categoryService.list();
      return todas.find((c) => c.Slug === slug) ?? null;
    },
    enabled: Boolean(slug),
    staleTime: 10 * 60 * 1000,
  });
